import React, { useEffect, useState } from 'react'
import Modal from '../../../../common/modal'
import SearchIcon from '@mui/icons-material/Search'
import { Button } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info';
import { isEmpty } from '../../../../common/helper';
import '../../../../../css/partyMasterStyles/AssignCitiesModal.scss'
import { alertAtom } from '../../../../common/jotaiState/globalStateAtoms';
import { useAtom } from 'jotai';

const AssignCitiesModal = (props) => {
    const {
        dataValues: { headerText, updateModal, setFilters, filters, cityOptList } } = props
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const [list1, setList1] = useState([]);
    const [list2, setList2] = useState([]);
    const [draggedItem, setDraggedItem] = useState(null);
    const [searchTerm1, setSearchTerm1] = useState('');
    const [searchTerm2, setSearchTerm2] = useState('');
    const [movingData, setMovingData] = useState({ cityName: null, List: "" });
    const [, setAlert] = useAtom(alertAtom)
    useEffect(() => {
        if (!isEmpty(filters) &&filters?.CityID?.length > 0 &&filters?.PartyCitiesNames?.length > 0) {
            const ids = filters.CityID.split('~').map(x => x.trim());
            const names = filters.PartyCitiesNames.split(',').map(x => x.trim());

            const selected = ids.map((id, index) => ({
                CityID: id,
                CityName: names[index] || ""
            }));

            setList2(selected);
            setList1(prev => prev.filter(
                x => !ids.includes(String(x.CityID))
            ));
        }
    }, [filters?.PartyCitiesNames])
    useEffect(() => {
        if (cityOptList?.length > 0) {
            setList1(cityOptList)
        } else {
            setList1([])
        }
    }, [cityOptList])
    const onDragStart = (event, item, fromList) => {
        setDraggedItem({ item, fromList });
    };

    const onDrop = (event, toList) => {
        event.preventDefault();
        const { item, fromList } = draggedItem || {};
        if (!item) return;

        if (fromList !== toList) {
            if (fromList === 'list1') {
                setList1(list1.filter(c => String(c.CityID) !== String(item.CityID)));
                setList2([...list2, item]);
            } else {
                setList2(list2.filter(c => String(c.CityID) !== String(item.CityID)));
                setList1([...list1, item]);
            }
        }
        setDraggedItem(null);
    };

    const onDragOver = (event) => {
        event.preventDefault();
    };

    const handleMoveRight = () => {
        const city = movingData?.cityName;
        if (!city || movingData?.List !== "list1") return;

        if (!list2.some(c => String(c.CityID) === String(city.CityID))) {
            setList1(list1.filter(c => String(c.CityID) !== String(city.CityID)));
            setList2([...list2, city]);
        }
    };
    const handleMoveLeft = () => {
        const city = movingData?.cityName;
        if (!city || movingData?.List !== "list2") return;
        if (!list1.some(c => String(c.CityID) === String(city.CityID))) {
            setList2(list2.filter(c => String(c.CityID) !== String(city.CityID)));
            setList1([...list1, city]);
        }
    };
    const filterList = (list, searchTerm) => {
        return list?.filter((city) =>
            city?.CityName?.toLowerCase()?.includes(searchTerm.toLowerCase())
        );
    };
    const handleSaveCities = () => {
         if (!list2 || list2.length === 0) {
        setAlert({ show: true, msg: "Please assign at least one city.", nextId: '' })
        return; 
    }
        const cityIDs = list2.map(item => item.CityID).join('~');
        const cityNames = list2.map(item => item.CityName).join(', ');
        setFilters((prev) => ({
            ...prev,
            PartyCitiesNames: cityNames,
            CityID: cityIDs
        }))
        updateModal()
    }
    return (
        <>
            <Modal
                headTxt={headerText}
                width={'65%'}
                updateModal={updateModal}
                closeId={"closeButton"}
                modalClass={'booking-popup'}
                modalStyle={modalStyle}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '16px', flex: 1 }}>
                    <div
                        style={{
                            display: 'flex', flexDirection: 'column', width: '45%', height: '250px', overflow: 'hidden', border: "1px solid rgba(166, 168, 171, 1)", borderRadius: '6px'

                        }}
                        onDrop={(e) => onDrop(e, 'list1')}
                        onDragOver={onDragOver}
                        data-list="list1"
                    >
                        <div style={{ backgroundColor: '#BFE1FF', color: '#444444', fontSize: '12px', fontWeight: '600', padding: '8px', borderTopLeftRadius: '6px', borderTopRightRadius: '6px', height: '35px' }}>
                        Cities List
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', borderBottom: '0.5px solid #A6A8AB', height: '35px', padding: '6px 12px 6px 12px' }}>
                            <span className='search--icon'><SearchIcon style={{ color: '#666666' }} /></span>
                            <input
                                type="text"
                                placeholder="Search By City"
                                value={searchTerm1}
                                onChange={(e) => setSearchTerm1(e.target.value)}
                                style={{ marginLeft: '6px', flex: 1, fontSize: '12px', fontWeight: '400', color: '#666666' }}
                            />
                        </div>
                        <div className='scrollBlue' style={{ overflowY: 'auto', flex: 1 }}>
                            {filterList(list1, searchTerm1)?.map((city, index) => (
                                <div
                                    key={index}
                                    className="city-item"
                                    tabIndex={0}
                                    draggable
                                    onClick={() => setMovingData({ cityName: city, List: 'list1' })}
                                    onDragStart={(e) => onDragStart(e, city, 'list1')}
                                    style={{ padding: '10px 12px 6px 12px', height: '35px', fontSize: '12px', fontWeight: '500', color: '#444444', cursor: 'pointer' }}
                                >
                                    {city.CityName}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', padding: '75px 10px 50px 10px', gap: '50px' }}>
                        <span onClick={handleMoveRight}><svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 15.75C0 19.7282 1.58035 23.5436 4.3934 26.3566C7.20644 29.1696 11.0218 30.75 15 30.75C18.9782 30.75 22.7936 29.1696 25.6066 26.3566C28.4196 23.5436 30 19.7282 30 15.75C30 11.7718 28.4196 7.95644 25.6066 5.1434C22.7936 2.33035 18.9782 0.75 15 0.75C11.0218 0.75 7.20644 2.33035 4.3934 5.1434C1.58035 7.95644 0 11.7718 0 15.75ZM16.4648 23.3086C15.9141 23.8594 15.0234 23.8594 14.4785 23.3086C13.9336 22.7578 13.9277 21.8672 14.4785 21.3223L18.6387 17.1621L7.96875 17.1562C7.18945 17.1562 6.5625 16.5293 6.5625 15.75C6.5625 14.9707 7.18945 14.3438 7.96875 14.3438H18.6387L14.4785 10.1836C13.9277 9.63281 13.9277 8.74219 14.4785 8.19727C15.0293 7.65234 15.9199 7.64648 16.4648 8.19727L23.0273 14.7539C23.5781 15.3047 23.5781 16.1953 23.0273 16.7402L16.4648 23.3086Z" fill="#157AFF" />
                        </svg>

                        </span>
                        <span onClick={handleMoveLeft}><svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M30 15.75C30 19.7282 28.4196 23.5436 25.6066 26.3566C22.7936 29.1696 18.9782 30.75 15 30.75C11.0218 30.75 7.20644 29.1696 4.3934 26.3566C1.58035 23.5436 0 19.7282 0 15.75C0 11.7718 1.58035 7.95644 4.3934 5.1434C7.20644 2.33035 11.0218 0.75 15 0.75C18.9782 0.75 22.7936 2.33035 25.6066 5.1434C28.4196 7.95644 30 11.7718 30 15.75ZM13.5352 23.3086C14.0859 23.8594 14.9766 23.8594 15.5215 23.3086C16.0664 22.7578 16.0723 21.8672 15.5215 21.3223L11.3613 17.1621L22.0312 17.1562C22.8105 17.1562 23.4375 16.5293 23.4375 15.75C23.4375 14.9707 22.8105 14.3438 22.0312 14.3438H11.3613L15.5215 10.1836C16.0723 9.63281 16.0723 8.74219 15.5215 8.19727C14.9707 7.65234 14.0801 7.64648 13.5352 8.19727L6.97266 14.7539C6.42188 15.3047 6.42188 16.1953 6.97266 16.7402L13.5352 23.3086Z" fill="#157AFF" />
                        </svg>

                        </span>
                    </div>
                    <div
                        style={{ display: 'flex', flexDirection: 'column', width: '45%', height: '250px', overflow: 'hidden', border: "1px solid rgba(166, 168, 171, 1)", borderRadius: '6px' }}
                        onDrop={(e) => onDrop(e, 'list2')}
                        onDragOver={onDragOver}
                        data-list="list2"
                    >
                        <div style={{ backgroundColor: '#BFE1FF', color: '#444444', fontSize: '12px', fontWeight: '600', padding: '8px', borderTopLeftRadius: '6px', borderTopRightRadius: '6px', height: '35px' }}>
                            Selected Cities List
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', borderBottom: '0.5px solid #A6A8AB', height: '35px', padding: '6px 12px 6px 12px' }}>
                            <span className='search--icon'><SearchIcon style={{ color: '#666666' }} /></span>
                            <input
                                type="text"
                                placeholder="Search By City"
                                value={searchTerm2}
                                onChange={(e) => setSearchTerm2(e.target.value)}
                                style={{ marginLeft: '6px', flex: 1, fontSize: '12px', fontWeight: '400', color: '#666666' }}
                            />
                        </div>
                        <div className='scrollBlue' style={{ overflowY: 'auto', flex: 1 }}>
                            {filterList(list2, searchTerm2)?.map((city, index) => (
                                <div
                                    key={index}
                                    className="city-item"
                                    tabIndex={0}
                                    draggable
                                    onClick={() => setMovingData({ cityName: city, List: 'list2' })}
                                    onDragStart={(e) => onDragStart(e, city, 'list2')}
                                    style={{ padding: '10px 12px 6px 12px', height: '35px', fontSize: '12px', fontWeight: '500', color: '#444444', cursor: 'pointer' }}
                                >
                                    {city.CityName}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="modal-btn-grp" style={{ borderTop: '1px solid rgba(166, 168, 171, 1)', display: 'flex', justifyContent: 'space-between', padding: '16px 0px 16px 16px', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}> {/* Added this div */}
                        <span style={{ color: '#0086FF', paddingRight: '15px' }}><InfoIcon style={{ fontSize: '20px' }} /> </span><span style={{ fontFamily: 'Roboto', fontSize: '14px', fontWeight: '500', color: '#0086FF' }}>You can drag and drop cities </span>
                    </div>
                    <Button id='saveAddressBtn' className="btn btn-primary margin-normal"
                        onClick={handleSaveCities}
                    >
                        Save
                    </Button>
                </div>

            </Modal>
        </>
    )
}

export default AssignCitiesModal
